import React from 'react';
import { Badge, Dropdown } from 'react-bootstrap';
import { IconEdit, IconTrash } from '@tabler/icons-react';
import RequireAuth from '../../../auth/middleware/RequireAuth';
import ReadOnlyGuard from '../../../shared/components/ReadOnlyGuard';
import { StockItem } from '../types';

interface StockItemsTableProps {
    items: StockItem[];
    onEdit: (id: string) => void;
    onDelete: (id: string) => void;
}

const StockItemsTable: React.FC<StockItemsTableProps> = ({
    items,
    onEdit,
    onDelete
}) => {
    return (
        <>
            {/* Desktop Table */}
            <table className="table table-striped d-none d-md-table">
                <thead>
                    <tr>
                        <th>Item Name</th>
                        <th>Category</th>
                        <th>Quantity</th>
                        <th>Unit</th>
                        <th>Status</th>
                        <th className='text-end'>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {items.length > 0 ? items.map((item) => (
                        <tr key={item.id}>
                            <td>{item.name}</td>
                            <td>
                                <Badge bg="info" className="fs-6 text-white">
                                    {item.category}
                                </Badge>
                            </td>
                            <td>{item.quantity}</td>
                            <td>{item.unit}</td>
                            <td>
                                <Badge bg={item.status === 'In Stock' ? 'success' : item.status === 'Low Stock' ? 'warning' : 'danger'} className="fs-6 text-white">
                                    {item.status}
                                </Badge>
                            </td>
                            <td className="text-end">
                                <Dropdown>
                                    <Dropdown.Toggle variant="default" id={`dropdownItem-${item.id}`}>
                                        Actions
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <RequireAuth requiredRoles={['dev']} requiredPermissions={['stock_inventory_update']} asComponent>
                                            <ReadOnlyGuard mode="hide">
                                                <Dropdown.Item href="#" onClick={() => onEdit(item.id.toString())}>
                                                    <IconEdit size={14} className="me-2" />
                                                    Edit
                                                </Dropdown.Item>
                                            </ReadOnlyGuard>
                                        </RequireAuth>
                                        <RequireAuth requiredRoles={['dev']} requiredPermissions={['stock_inventory_delete']} asComponent>
                                            <ReadOnlyGuard mode="hide">
                                                <Dropdown.Item href="#" onClick={() => onDelete(item.id.toString())} className='text-danger'>
                                                    <IconTrash size={14} className="me-2" />
                                                    Remove
                                                </Dropdown.Item>
                                            </ReadOnlyGuard>
                                        </RequireAuth>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={6} className="text-center">No items found.</td>
                        </tr>
                    )}
                </tbody>
            </table>

            {/* Mobile Cards */}
            <div className="d-md-none">
                {items.length > 0 ? items.map((item) => (
                    <div key={item.id} className="card mb-3">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-start">
                                <div className="flex-grow-1">
                                    <h6 className="card-title mb-2">{item.name}</h6>
                                    <div className="mb-2">
                                        <Badge bg="info" className="me-2 fs-6 text-white">
                                            {item.category}
                                        </Badge>
                                        <Badge bg={item.status === 'In Stock' ? 'success' : item.status === 'Low Stock' ? 'warning' : 'danger'} className="fs-6 text-white">
                                            {item.status}
                                        </Badge>
                                    </div>
                                    <div className="text-muted small">
                                        Quantity: {item.quantity} {item.unit}
                                    </div>
                                </div>
                                <Dropdown>
                                    <Dropdown.Toggle variant="default" id={`dropdownMobileItem-${item.id}`}>
                                        Actions
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <RequireAuth requiredRoles={['dev']} requiredPermissions={['stock_inventory_update']} asComponent>
                                            <ReadOnlyGuard mode="hide">
                                                <Dropdown.Item href="#" onClick={() => onEdit(item.id.toString())}>
                                                    <IconEdit size={14} className="me-2" />
                                                    Edit
                                                </Dropdown.Item>
                                            </ReadOnlyGuard>
                                        </RequireAuth>
                                        <RequireAuth requiredRoles={['dev']} requiredPermissions={['stock_inventory_delete']} asComponent>
                                            <ReadOnlyGuard mode="hide">
                                                <Dropdown.Item href="#" onClick={() => onDelete(item.id.toString())} className='text-danger'>
                                                    <IconTrash size={14} className="me-2" />
                                                    Remove
                                                </Dropdown.Item>
                                            </ReadOnlyGuard>
                                        </RequireAuth>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                )) : (
                    <div className="text-center my-4">No items found.</div>
                )}
            </div>
        </>
    );
};

export default StockItemsTable;
